import { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

const AccountHubSkeleton: FC = () => (
  <Box sx={{ backgroundColor: 'background.default', minHeight: '100%' }}>
    {/* Header skeleton */}
    <Skeleton variant="rectangular" height={80} animation="wave" />
    <Stack gap={2} sx={{ p: 3 }}>
      {/* Profile card */}
      <Skeleton variant="rounded" height={120} animation="wave" />
      {/* Language card */}
      <Skeleton variant="rounded" height={72} animation="wave" />
      {/* Menu card */}
      <Skeleton variant="rounded" height={280} animation="wave" />
    </Stack>
  </Box>
);

export default AccountHubSkeleton;
